// client/src/components/admin/marketer/PointRefundSummary.js
import React, { useState, useEffect } from 'react';
import '../../../styles/admin/AdminTable.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function PointRefundSummary({ interactive = false, onSelect, selectedId, refreshToken }) {
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshToken]);

  const fetchList = async () => {
    setLoading(true);
    setError('');
    try {
      // 목록 조회 (최대 20개 정도만 표시)
      const res = await fetch(`${API_URL}/api/admin/advertiser/refund/list?page=1&pageSize=20`, {
        credentials: 'include'
      });
      const result = await res.json();
      
      if (result.ok) {
        setItems(result.items || []);
      } else {
        setError('불러오기 실패');
      }
    } catch (err) {
      console.error('fetchList error:', err);
      setError('불러오기 실패');
    }
    setLoading(false);
  };

  const fmt = (ts) => ts ? new Date(ts).toLocaleString('ko-KR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  }) : '';

  return (
    <div className="admin-list">
      <div className="admin-list__header">광고주 환불 요청</div>
      
      <div className="admin-list__body admin-list__body--fixed-height">
        {error && <div className="admin-list__error">{error}</div>}
        {loading && <div className="admin-list__loading">불러오는 중...</div>}
        {!loading && items.length === 0 && !error && <div className="admin-list__empty">환불 요청이 없습니다.</div>}
        
        {!loading && items.length > 0 && (
          <div>
            {items.map((item) => (
              <div
                key={item._id}
                onClick={interactive && onSelect ? () => onSelect(item) : undefined}
                className={`admin-list__item ${
                  selectedId === item._id ? 'admin-list__item--selected' : ''
                }`}
                style={{ cursor: interactive ? 'pointer' : 'default' }}
              >
                <div className="admin-list__item-row">
                  <div className="admin-list__item-main">
                    {item.marketerUserId} ({item.marketerUserName})
                  </div>
                  <div className="admin-list__item-sub">{fmt(item.requestedAt)}</div>
                </div>
                <div className="admin-list__item-meta">
                  {item.requestedPoints.toLocaleString()}pt → {item.refundAmount.toLocaleString()}원
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default PointRefundSummary;

